export const getAllPartWise = (apiData: any) => {
  const output = [];
  let totalRejection = 0;
  for (const PartName in apiData) {
    const rejectionCount = apiData[PartName].reduce(
      (sum: number, num: number) => sum + num
    );
    totalRejection += rejectionCount;
    if (rejectionCount > 0) {
      output.push({
        PartName,
        partCountDefectWise: apiData[PartName],
        rejectionCount,
        cummulativeRejection: 0,
        cummPercenatge: '',
      });
    }
  }
  output.sort((a, b) => b.rejectionCount - a.rejectionCount);
  let cumCount = 0;
  for (const item of output) {
    cumCount += item.rejectionCount;
    item.cummulativeRejection = cumCount;
    item.cummPercenatge = ((cumCount * 100) / totalRejection).toFixed(2);
  }
  return output;
};

export const getNewApiData = (apiData: any) => {
  const defectsNames = [
    'Machine under preventive maintenance',
          'Machine under break down',
          'Die/Tool/Mould under preventive maintenance',
          'Die/Tool/Mould under break down',
          'Machine parameters found out of spec. during routine checking',
          'Power Failure',
          'Repeated Power Failure',
          'Power Source changed with intimation',
          'Power Source changed after power failure',
  ];

  const output = [];
  let totalSum = 0;
  for (let i = 0; i < defectsNames.length; i++) {
    let sum = 0;
    for (const partName in apiData) {
      sum += apiData[partName][i];
    }
    totalSum += sum;
    if (sum > 0) {
      output.push({
        defectName: defectsNames[i],
        count: sum,
        totalSum: totalSum,
      });
    }
  }

  return output;
};
export const getCumulativePercenatge = (apiData: any) => {
  const output = getNewApiData(apiData);
  const totalSum = output[output.length - 1]?.totalSum;
  const result = output.map((item: any) =>
    ((item.totalSum * 100) / totalSum).toFixed(2)
  );
  return result;
};